// Firebase 설정 및 초기화
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore, initializeFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

// 환경변수 디버깅
//console.log('🔍 환경변수 확인:');
//console.log('NODE_ENV:', process.env.NODE_ENV);
//console.log('REACT_APP_USE_FIRESTORE_EMULATOR:', process.env.REACT_APP_USE_FIRESTORE_EMULATOR);

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const storage = getStorage(app);
const auth = getAuth(app);

// ✅ Firestore 멀티 데이터베이스 분기
const databaseId = process.env.REACT_APP_FIREBASE_DB_ID;

// Firestore 설정 최적화 (고동시접속 대응)
const db = initializeFirestore(app, {
  databaseId,
  // 동시 연결 수 제한 (기본값: 10)
  experimentalForceLongPolling: true, // 안정적인 연결을 위한 long polling
  useFetchStreams: false, // 호환성을 위해 비활성화
  // 캐시 설정
  cacheSizeBytes: 50 * 1024 * 1024, // 50MB 캐시
}, databaseId);

// 연결 상태 모니터링
let connectionRetryCount = 0;
const MAX_RETRY_COUNT = 3;

// 전역 에러 핸들러
const handleFirestoreError = (error) => {
  //console.error('Firestore 오류:', error);
  
  // 연결 제한 오류 처리
  if (error.code === 'resource-exhausted' || error.code === 'unavailable') {
    connectionRetryCount++;
    if (connectionRetryCount <= MAX_RETRY_COUNT) {
      //console.warn(`Firestore 재연결 시도 ${connectionRetryCount}/${MAX_RETRY_COUNT}`);
      // 5초 후 재연결 시도
      setTimeout(() => {
        window.location.reload();
      }, 5000);
    } else {
      //console.error('최대 재연결 시도 횟수 초과');
      // 사용자에게 알림
      alert('서버 연결이 불안정합니다. 잠시 후 다시 시도해주세요.');
    }
  }
};

// 개발 환경에서 에뮬레이터 연결
// console.log('🔍 에뮬레이터 연결 조건 확인:');
// console.log('- NODE_ENV === development:', process.env.NODE_ENV === 'development');
// console.log('- REACT_APP_USE_FIRESTORE_EMULATOR === true:', process.env.REACT_APP_USE_FIRESTORE_EMULATOR === 'true');

// if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_USE_FIRESTORE_EMULATOR === 'true') {
//   try {
//     connectFirestoreEmulator(db, 'localhost', 8080);
//     console.log('✅ Firestore 에뮬레이터에 연결되었습니다.');
//   } catch (error) {
//     console.warn('❌ Firestore 에뮬레이터 연결 실패:', error);
//   }
// } else {
//   console.log('ℹ️ Firestore 에뮬레이터 연결 조건이 충족되지 않아 실제 Firebase를 사용합니다.');
// }

export { app, analytics, storage, auth, db, handleFirestoreError };